import React from 'react';
import Visa from './img/visa.svg';
import MasterCard from './img/mastercard.svg';
import Elo from './img/elo.svg';
import Amex from './img/amex.svg';
import Hipercard from './img/hipercard.svg';
import './index.css';

const Bandeiras = () => (
    <div className="card-flags">
        <img className="card-flag" alt="visa" src={Visa} />
        <img className="card-flag" alt="master" src={MasterCard} />
        <img className="card-flag" alt="elo" src={Elo} />
        <img className="card-flag" alt="amex" src={Amex} />
        <img className="card-flag" alt="hiper" src={Hipercard} />
    </div>
);

export default Bandeiras;
